import { render, staticRenderFns } from "./BookShare.vue?vue&type=template&id=94a18e76&scoped=true&"
import script from "./BookShare.vue?vue&type=script&lang=js&"
export * from "./BookShare.vue?vue&type=script&lang=js&"
import style0 from "./BookShare.vue?vue&type=style&index=0&id=94a18e76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a18e76",
  null
  
)

export default component.exports